import { distinctUntilChanged } from 'rxjs/operators';
import { MonoTypeOperatorFunction } from 'rxjs';
import { isEqual } from 'lodash';

export function distinctUntilChangedDeep<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged((a, b) => isEqual(a, b));
}
